import React, { useState, useEffect } from 'react'
import Footer from '../component/Footer'
import { Link } from 'react-router-dom'
import api from '../api'

const Faqs = () => {
    const [faqs, setFaqs] = useState([])
    const [openIndex, setOpenIndex] = useState(null)

    useEffect(() => {
        getFaqs()
        window.scrollTo({ top: 0, behavior: 'auto' })
    }, [])

    const getFaqs = async () => {
        try {
            const res = await api.get("/admin/cms/faqs")
            setFaqs(res.data?.faqs || [])
        } catch (err) {
            console.log("Failed to fetch FAQs", err)
        }
    }

    const toggle = (index) => {
        setOpenIndex(prev => prev === index ? null : index)
    }

    return (
        <>
            <main className="main__content_wrapper">
                <section className="section--padding mb-95">

                    <div className="section__heading text-center mb-40">
                        <h2 className="section__heading--maintitle">Frequently asked questions (Faqs)</h2>
                    </div>

                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                {faqs.map((faq, index) => (
                                    <div
                                        key={faq._id}
                                        style={{
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '10px',
                                            marginBottom: '12px',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <div
                                            onClick={() => toggle(index)}
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '18px 20px',
                                                cursor: 'pointer',
                                                backgroundColor: '#f8f8f8',
                                                gap: '12px'
                                            }}
                                        >
                                            <span style={{ fontWeight: 500, fontSize: '15px' }}>
                                                {faq.question}
                                            </span>
                                            <span style={{
                                                width: 28, height: 28,
                                                borderRadius: '50%',
                                                border: '1.5px solid #ccc',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                flexShrink: 0,
                                                fontSize: '20px', fontWeight: 400,
                                                transform: openIndex === index ? 'rotate(45deg)' : 'none',
                                                transition: 'transform 0.25s'
                                            }}>+</span>
                                        </div>

                                        {openIndex === index && (
                                            <div style={{ padding: '16px 20px', fontSize: '15px', color: '#555', lineHeight: 1.7 }}>
                                                {faq.answer}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    )
}

export default Faqs